import { render, staticRenderFns } from "./registerStep2.vue?vue&type=template&id=460d3b3c&"
import script from "./registerStep2.vue?vue&type=script&lang=js&"
export * from "./registerStep2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "registerStep2.vue"
export default component.exports